'use client';

import { Breadcrumb, BreadcrumbElement } from '@components/breadcrumb';

interface HomeBreadcrumbProps {
    isMobilePlan: boolean;
}

export function HomeBreadcrumb({ isMobilePlan }: Readonly<HomeBreadcrumbProps>) {
    const config = isMobilePlan
        ? {
              plansLabel: 'Forfaits mobiles',
              plansHref: '/forfaits-mobiles/avec-engagement',
              wallLabel: 'Forfaits sans engagement',
          }
        : {
              plansLabel: 'Box internet',
              plansHref: '/offres-internet/sans-engagement',
              wallLabel: 'Box internet sans engagement',
          };

    const elements: BreadcrumbElement[] = [
        { name: 'home', label: 'Accueil', href: '/' },
        { name: 'plans', label: config.plansLabel, href: config.plansHref },
        { name: 'wall', label: config.wallLabel },
    ];

    return <Breadcrumb elements={elements} />;
}
